module.exports = __webpack_public_path__ + "static/media/dtj-color-mock-1.36c37b5f.jpg";